import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import PrepaidProgramDatatableRowMeta from './PrepaidProgramDatatableRowMeta';
export type TPrepaidProgramDataTableData = {
    primaryKey: string | number,
    // idTable: string,
    // nameTable: string,
    miscellaneousPeriodicCostsTable: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TPrepaidProgramDataTableData>()

export function getPrepaidProgramDataTableColumns({ isLoading, handleEdit }: Props) {
  
  return [
    columnHelper.accessor("miscellaneousPeriodicCostsTable",
        {
            id: "idTable",
            header: "ID",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>
                    {PrepaidProgramDatatableRowMeta.miscellaneousPeriodicCostsTable.options &&
                    PrepaidProgramDatatableRowMeta.miscellaneousPeriodicCostsTable.options.map((opt, i) => (
                        opt.value == props.getValue() && 
                        <span key={i}>{opt.value}</span>
                    ))}
                    </Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("miscellaneousPeriodicCostsTable",
        {
            id: "nameTable",
            header: "Nom",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>
                    {PrepaidProgramDatatableRowMeta.miscellaneousPeriodicCostsTable.options &&
                    PrepaidProgramDatatableRowMeta.miscellaneousPeriodicCostsTable.options.map((opt, i) => (
                        opt.value == props.getValue() && 
                        <span key={i}>{opt.label}</span>
                    ))}
                    </Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <Button
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}
                            mr={'1rem'}
                        >
                            Editer
                        </Button>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
